// auth/signInWithApple.web.ts
import {
  getAuth,
  getRedirectResult,
  OAuthProvider,
  signInWithCredential,
  signInWithPopup,
  signInWithRedirect,
  type UserCredential,
} from 'firebase/auth'
import { handleAuthWithCredential } from '../handleAuthWithCredential'

export const signInWithApple = async () => {
  const auth = getAuth()
  const provider = new OAuthProvider('apple.com')
  provider.addScope('email')
  provider.addScope('name')

  try {
    // Prefer popup
    const result: UserCredential = await signInWithPopup(auth, provider)

    // ✅ Correct way to get the credential (typed)
    const credential = OAuthProvider.credentialFromResult(result)
    if (!credential) throw new Error('No Apple OAuth credential returned from popup')

    // You can pass the credential to your existing flow so it can link/migrate, etc.
    const final = await handleAuthWithCredential(credential, () => signInWithCredential(auth, credential), result.user?.email ?? null)

    return { provider: 'apple', user: final.user }
  } catch (err: any) {
    // Fallback to redirect if popup blocked
    if (err?.code === 'auth/popup-blocked') {
      await signInWithRedirect(getAuth(), provider)
      const result = await getRedirectResult(getAuth())
      if (!result) throw new Error('Redirect did not return a result')

      const credential = OAuthProvider.credentialFromResult(result)
      if (!credential) throw new Error('No Apple OAuth credential returned from redirect')

      const final = await handleAuthWithCredential(
        credential,
        () => signInWithCredential(getAuth(), credential),
        result.user?.email ?? null
      )

      return { provider: 'apple', user: final.user }
    }

    // If Firebase throws a provider-specific error, you can inspect the credential too:
    // const failedCred = OAuthProvider.credentialFromError(err)
    throw err
  }
}
